const getRemovedItemsMessage = (messages = {}, removedItemsRestrictions = []) => {
    const { removedItemsMessage } = messages?.basket || {}
    if (removedItemsRestrictions.includes('ITEM_FFM_RESTRICTED')) {
        return removedItemsMessage?.restrict
    }
    if (removedItemsRestrictions.includes('CART_ITEM_INVALID')) {
        return removedItemsMessage?.unavailable
    }
    if (removedItemsRestrictions.includes('RESERVATION_NUMBER_INVALID')) {
        return messages.cartRectification.RESERVATION_NUMBER_INVALID
    }
    return removedItemsMessage?.soldOut
}

const getRemovedItemsTitle = (messages = {}, removedItemsRestrictions = []) => {
    if (removedItemsRestrictions.includes('RESERVATION_NUMBER_INVALID')) {
        return () => ''
    }
    return messages.basket.soldout.itemsCount
}

export { getRemovedItemsMessage, getRemovedItemsTitle }
